import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';
import { IMG } from '../data/realImages';

// One image per industry strip, mapped in order (Almacenamiento removed)
const IMAGES = [
  IMG.agriculture[0],   // Agriculture
  IMG.construction[0],  // Construction
  IMG.industrial[0],    // Industrial Operations
  IMG.industrial[2],    // Infrastructure
  IMG.electrical[0],    // Electrical Engineering
  IMG.industrial[4],    // Industrial Maintenance
  IMG.workforce[0],     // Workforce-Intensive
];

export default function Industries() {
  const { t } = useLang();
  const items = t('industries.items');
  const [hover, setHover] = useState(-1);

  return (
    <section id="industries" data-testid="industries-section" className="relative py-24 md:py-40 border-t border-[#27272A]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal className="section-index">{t('industries.index')}</Reveal>
            <Reveal as="h2" className="h-section text-[#F5F5F2] mt-4 max-w-3xl reveal-delay-1">
              {t('industries.title')}
            </Reveal>
          </div>
          <Reveal className="text-[#A1A1AA] max-w-md text-sm md:text-base leading-relaxed reveal-delay-2">
            {t('industries.sub')}
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Strips */}
          <div className="lg:col-span-7">
            <div className="border-t border-[#27272A]">
              {items.map((it, i) => (
                <div
                  key={it.title}
                  data-testid={`industry-row-${i}`}
                  onMouseEnter={() => setHover(i)}
                  onMouseLeave={() => setHover(-1)}
                  className="industry-row group flex items-center justify-between border-b border-[#27272A] py-6 md:py-7 cursor-default"
                >
                  <div className="flex items-baseline gap-6">
                    <span className="font-mono text-[10px] tracking-[0.3em] text-[#C8102E]">{String(i + 1).padStart(2, '0')}</span>
                    <div>
                      <div className="font-display text-2xl md:text-3xl tracking-tight text-[#F5F5F2]">
                        {it.title}
                      </div>
                      <div className={`text-sm text-[#A1A1AA] overflow-hidden transition-[max-height,margin] duration-500 ${hover === i ? 'max-h-20 mt-2' : 'max-h-0 mt-0'}`}>
                        {it.desc}
                      </div>
                    </div>
                  </div>
                  <Plus size={18} className={`transition-transform duration-300 text-[#A1A1AA] ${hover === i ? 'rotate-45 text-[#C8102E]' : ''}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Sticky image */}
          <div className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-[100px] aspect-[4/5] border border-[#27272A] overflow-hidden">
              <img
                src={hover >= 0 ? IMAGES[hover] : IMAGES[0]}
                alt="Industry visual"
                className="w-full h-full object-cover transition-opacity duration-500"
                key={hover}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B]/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between font-mono text-[10px] tracking-[0.3em] uppercase text-[#F5F5F2]">
                <span>{hover >= 0 ? items[hover].title : items[0].title}</span>
                <span className="text-[#C8102E]">A7</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
